export const policyCancellationReasons = [
  {
    value: 'payment_dispute',
    label: 'POLICY_CANCELLATION.reasons.paymentDispute',
    isAdminOnly: true,
  },
  {
    value: 'personal_reason',
    label: 'POLICY_CANCELLATION.reasons.personalReason',
    isAdminOnly: false,
  },
  {
    value: 'supplier_change',
    label: 'POLICY_CANCELLATION.reasons.supplierChange',
    isAdminOnly: false,
  },
  {
    value: 'trip_cancelled',
    label: 'POLICY_CANCELLATION.reasons.tripCancelled',
    isAdminOnly: false,
  },
  {
    value: 'other',
    label: 'POLICY_CANCELLATION.reasons.other',
    isAdminOnly: true,
  },
  {
    value: 'not_eligible',
    label: 'POLICY_CANCELLATION.reasons.notEligible',
    isAdminOnly: false,
  },
];
